module.exports = __webpack_public_path__ + "img/curveline.47c5561c.png";